module.exports = __webpack_public_path__ + "img/pakistan.e5c80180.svg";